const routes = [
  {
    path: '/competitor-sales',
    name: 'competitor-sales',
    component: () => import('@/modules/competitor-sales/pages/CompetitorSales.vue'),
    meta: {
      requiresAuth: true,
      title: 'eRank — Competitor Sales',
      metaTags: [
        {
          name: 'description',
          content: 'Allows you to track the estimated daily number of sales for the shops of your choice.',
        },
        {
          page_slug: 'competitor-sales',
        },
      ],
    },
  },
];

export default routes;